import React, { useContext, useEffect, useRef, useState } from 'react';
import { Stack, TextField } from 'office-ui-fabric-react';
import { secureRequest } from '../../../../../../utils/request';

import { context } from './context';
import { Route as RouteElement, RouteFormValues } from './Modes.types';
import { ModalInput } from './ModalInput';
import { Formik, FormikProps } from 'formik';
import { SubmitOnEveryChange } from '../../../components/SubmitOnEveryChange';
import { mapContext } from '../../mapContext';

export const Route: React.FC = () => {
  const formikRef = useRef<FormikProps<RouteFormValues>>(null);
  const { setFilteredRoutes, routes, filteredRoutes } = useContext(mapContext);

  const onSubmit = (values: RouteFormValues) => {
    const result =
      values.name.length > values.short_name.length
        ? values.name
        : values.short_name;
      setFilteredRoutes(result);
  };

  useEffect(() => {
    formikRef.current?.setFieldValue('name', filteredRoutes);
    formikRef.current?.setFieldValue('short_name', filteredRoutes);
  }, [filteredRoutes]);

  return (
    <context.Provider
      value={{
        list: routes,
      }}
    >
      <Formik<RouteFormValues>
        innerRef={formikRef as never}
        onSubmit={onSubmit}
        initialValues={{
          name: [],
          short_name: [],
        }}
      >
        {() => (
          <>
            <SubmitOnEveryChange />
            <Stack tokens={{ childrenGap: 16 }}>
              <ModalInput name="name" label="Наименование маршрута" />
              <ModalInput name="short_name" label="Номер маршрута" />
            </Stack>
          </>
        )}
      </Formik>
    </context.Provider>
  );
};
